import { ButtonComponentProps, DeleteButtonComponentProps } from "@quillsql/react"
import { ReactNode } from "react"

import { faIcon } from "@utils/faIcon"

import { Button, IconButton, Tooltip } from "@atoms/index"

import styles from "./QuillButton.module.scss"

function QuillButtonIcon(props: { icon: ReactNode }) {
    const { icon } = props
    return <span className={styles.buttonIcon}>{icon}</span>
}

export function QuillButton(props: ButtonComponentProps) {
    const { primary, label, icon, tooltipText, onClick, width, disabled, isLoading } = props

    return (
        <Tooltip body={tooltipText} isDisabled={!tooltipText}>
            <Button
                size="lg"
                variant={primary ? "solid" : "subtle"}
                isDisabled={disabled}
                isLoading={isLoading}
                onClick={onClick}
                style={width ? { width: width } : {}}
            >
                {icon ? <QuillButtonIcon icon={icon} /> : null}
                {label}
            </Button>
        </Tooltip>
    )
}

export function QuillDeleteButton(props: DeleteButtonComponentProps) {
    const { onClick } = props

    return (
        <Tooltip body="Remove">
            <IconButton
                size="lg"
                variant="ghost"
                icon={faIcon({ name: "xmark", style: "regular" })}
                onClick={onClick}
            />
        </Tooltip>
    )
}
